import React from "react";
import "./WesEval.css";
const WesEval = () => {
  return (
    <div className="wesEvalContainer">
      <h2>
        The <span>WES</span> Evaluation Process
      </h2>
      <p>
        The WES evaluation process is crucial for immigrating to Canada. WES
        document evaluation is unnecessary if you have completed your studies at
        universities or schools in Canada. We help students, immigrants, and job
        seekers migrate, study, work, and conduct business in Canada by
        assisting them with the WES evaluation procedure. Goodway Attestation
        assists candidates in obtaining university verification for WES from
        universities in India and other countries like the UAE, Kuwait, Qatar,
        Oman, Saudi Arabia, Bahrain, the USA, the UK, Australia, etc. We also
        help them get university transcripts from respective universities to
        complete the WES verification process.
      </p>
    </div>
  );
};

export default WesEval;
